import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App.tsx';
import Dashboard from './components/Dashboard';
import EmployeeList from './components/EmployeeList';
import EmployeeBanking from './components/EmployeeBanking';
import PayrollProcess from './components/PayrollProcess';
import Reports from './components/Reports';
import Compliance from './components/Compliance';
import Settings from './components/Settings';
import TimeClock from './components/TimeClock';
import Timesheet from './components/Timesheet';
import Layout from './components/Layout';
import ResetPassword from './components/ResetPassword';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/reset-password',
    element: <ResetPassword />
  },
  {
    element: <App />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: 'employees',
            element: <EmployeeList />,
          },
          {
            path: 'banking',
            element: <EmployeeBanking />,
          },
          {
            path: 'payroll',
            element: <PayrollProcess />,
          },
          {
            path: 'reports',
            element: <Reports />,
          },
          {
            path: 'compliance',
            element: <Compliance />,
          },
          {
            path: 'settings',
            element: <Settings />,
          },
          {
            path: 'timeclock',
            element: <TimeClock />,
          },
          {
            path: 'timesheet',
            element: <Timesheet />,
          },
        ],
      },
    ],
  },
]);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);